<app-side-menu>
  <div class="preventive-maintenance-details-content">
    <div class="page-header">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <button type="button" class="btn btn-outline-secondary me-3" (click)="goBack()">
            <i class="fas fa-arrow-left me-2"></i>
            Voltar
          </button>
          <div>
            <h1 class="page-title">
              <i class="fas fa-tools me-3"></i>
              Detalhes da Preventiva
            </h1>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="loading-container">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
      <p>Carregando detalhes da preventiva...</p>
    </div>

    <!-- Error -->
    <div *ngIf="error && !loading" class="alert alert-danger alert-dismissible fade show" role="alert">
      <i class="fas fa-exclamation-triangle"></i> {{ error }}
      <button type="button" class="btn-close" (click)="error = null"></button>
    </div>

    <!-- Detalhes -->
    <div *ngIf="preventiveMaintenance && !loading" class="details-container">
      <div class="row">
        <!-- Coluna Principal -->
        <div class="col-md-8">
          <!-- Card de Informações Básicas -->
          <div class="details-card">
            <div class="card-header">
              <div>
                <h3>{{ preventiveMaintenance.maintenanceName }}</h3>
              </div>
              <span class="badge" [ngClass]="{'badge-success': preventiveMaintenance.isActive, 'badge-secondary': !preventiveMaintenance.isActive}">
                {{ preventiveMaintenance.isActive ? 'Ativa' : 'Inativa' }}
              </span>
            </div>

            <div class="card-body">
              <div class="info-section">
                <h4><i class="fas fa-info-circle"></i> Informações Gerais</h4>
                
                <div class="info-row" *ngIf="preventiveMaintenance.description">
                  <span class="info-label">Descrição:</span>
                  <span class="info-value">{{ preventiveMaintenance.description }}</span>
                </div>

                <div class="info-row" *ngIf="preventiveMaintenance.instructions">
                  <span class="info-label">Instruções:</span>
                  <span class="info-value">{{ preventiveMaintenance.instructions }}</span>
                </div>

                <div class="info-row" *ngIf="preventiveMaintenance.vehicleType">
                  <span class="info-label">Tipo de Veículo:</span>
                  <span class="info-value">
                    <span class="category-badge">{{ preventiveMaintenance.vehicleType }}</span>
                  </span>
                </div>

                <div class="info-row" *ngIf="preventiveMaintenance.vehicleBrand">
                  <span class="info-label">Marca:</span>
                  <span class="info-value">{{ preventiveMaintenance.vehicleBrand }}</span>
                </div>

                <div class="info-row" *ngIf="preventiveMaintenance.vehicleModel">
                  <span class="info-label">Modelo:</span>
                  <span class="info-value">{{ preventiveMaintenance.vehicleModel }}</span>
                </div>

                <div class="info-row" *ngIf="preventiveMaintenance.targetMileage">
                  <span class="info-label">Quilometragem Alvo:</span>
                  <span class="info-value">
                    <i class="fas fa-tachometer-alt"></i> {{ preventiveMaintenance.targetMileage | number }} km
                  </span>
                </div>

                <div class="info-row" *ngIf="preventiveMaintenance.estimatedDurationHours">
                  <span class="info-label">Duração Estimada:</span>
                  <span class="info-value">
                    <i class="fas fa-clock"></i> {{ preventiveMaintenance.estimatedDurationHours }} horas
                  </span>
                </div>
              </div>

              <!-- Custos -->
              <div class="info-section" *ngIf="preventiveMaintenance.estimatedCost">
                <h4><i class="fas fa-dollar-sign"></i> Custos</h4>

                <div class="pricing-grid">
                  <div class="pricing-item">
                    <span class="pricing-label">Custo Estimado</span>
                    <span class="pricing-value">
                      {{ preventiveMaintenance.estimatedCost | currency:'BRL':'symbol':'1.2-2' }}
                    </span>
                  </div>

                  <div class="pricing-item" *ngIf="preventiveMaintenance.items && preventiveMaintenance.items.length > 0">
                    <span class="pricing-label">Custo dos Itens</span>
                    <span class="pricing-value">
                      {{ calculateTotalItemsCost() | currency:'BRL':'symbol':'1.2-2' }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Itens da Preventiva -->
              <div class="info-section">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h4 class="mb-0"><i class="fas fa-list"></i> Itens da Preventiva ({{ preventiveMaintenance.items?.length || 0 }})</h4>
                  <button class="btn btn-primary btn-sm" (click)="openAddItemModal()">
                    <i class="fas fa-plus me-2"></i>
                    Adicionar Item
                  </button>
                </div>

                <div class="items-list" *ngIf="preventiveMaintenance.items && preventiveMaintenance.items.length > 0">
                  <div *ngFor="let item of preventiveMaintenance.items; let i = index" class="item-card">
                    <div class="item-header">
                      <h5>{{ item.itemName }}</h5>
                      <span class="badge" [ngClass]="{'badge-success': item.isRequired, 'badge-secondary': !item.isRequired}">
                        {{ item.isRequired ? 'Obrigatório' : 'Opcional' }}
                      </span>
                    </div>
                    <div class="item-body">
                      <div class="item-info-row" *ngIf="item.description">
                        <span class="item-label">Descrição:</span>
                        <span class="item-value">{{ item.description }}</span>
                      </div>
                      <div class="item-info-row" *ngIf="item.instructions">
                        <span class="item-label">Instruções:</span>
                        <span class="item-value">{{ item.instructions }}</span>
                      </div>
                      <div class="item-info-row">
                        <span class="item-label">Quantidade:</span>
                        <span class="item-value">{{ item.quantity }} {{ item.unit }}</span>
                      </div>
                      <div class="item-info-row" *ngIf="item.estimatedCost">
                        <span class="item-label">Custo Estimado:</span>
                        <span class="item-value">{{ item.estimatedCost | currency:'BRL':'symbol':'1.2-2' }}</span>
                      </div>
                      <div class="item-info-row" *ngIf="item.itemCode">
                        <span class="item-label">Código do Item:</span>
                        <span class="item-value">{{ item.itemCode }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Auditoria -->
              <div class="info-section" *ngIf="preventiveMaintenance.createdAt">
                <h4><i class="fas fa-history"></i> Informações de Auditoria</h4>

                <div class="info-row" *ngIf="preventiveMaintenance.createdAt">
                  <span class="info-label">Criado em:</span>
                  <span class="info-value">{{ preventiveMaintenance.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
                </div>

                <div class="info-row" *ngIf="preventiveMaintenance.createdBy">
                  <span class="info-label">Criado por:</span>
                  <span class="info-value">{{ preventiveMaintenance.createdBy }}</span>
                </div>

                <div class="info-row" *ngIf="preventiveMaintenance.updatedAt">
                  <span class="info-label">Última atualização:</span>
                  <span class="info-value">{{ preventiveMaintenance.updatedAt | date:'dd/MM/yyyy HH:mm' }}</span>
                </div>

                <div class="info-row" *ngIf="preventiveMaintenance.updatedBy">
                  <span class="info-label">Atualizado por:</span>
                  <span class="info-value">{{ preventiveMaintenance.updatedBy }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Coluna Lateral -->
        <div class="col-md-4">
          <!-- Card de Ações Rápidas -->
          <div class="quick-actions-card">
            <h4><i class="fas fa-bolt"></i> Ações Rápidas</h4>

            <button class="action-btn btn-block" (click)="editPreventiveMaintenance()">
              <i class="fas fa-pen-to-square"></i>
              <div>
                <strong>Editar Preventiva</strong>
                <small>Modificar informações da preventiva</small>
              </div>
            </button>

            <button class="action-btn btn-block btn-danger-outline" (click)="deletePreventiveMaintenance()">
              <i class="fas fa-trash-can"></i>
              <div>
                <strong>Excluir Preventiva</strong>
                <small>Remover permanentemente</small>
              </div>
            </button>
          </div>

          <!-- Card de Estatísticas -->
          <div class="stats-card">
            <h4><i class="fas fa-chart-bar"></i> Estatísticas</h4>

            <div class="stat-item">
              <div class="stat-icon" [style.background]="preventiveMaintenance.isActive ? '#d4edda' : '#f8d7da'">
                <i class="fas fa-toggle-on" [style.color]="preventiveMaintenance.isActive ? '#28a745' : '#dc3545'"></i>
              </div>
              <div class="stat-info">
                <span class="stat-label">Status</span>
                <span class="stat-value">{{ preventiveMaintenance.isActive ? 'Ativa' : 'Inativa' }}</span>
              </div>
            </div>

            <div class="stat-item" *ngIf="preventiveMaintenance.vehicleType">
              <div class="stat-icon" style="background: #cfe2ff;">
                <i class="fas fa-car" style="color: #0d6efd;"></i>
              </div>
              <div class="stat-info">
                <span class="stat-label">Tipo de Veículo</span>
                <span class="stat-value">{{ preventiveMaintenance.vehicleType }}</span>
              </div>
            </div>

            <div class="stat-item" *ngIf="preventiveMaintenance.targetMileage">
              <div class="stat-icon" style="background: #fff3cd;">
                <i class="fas fa-tachometer-alt" style="color: #ffc107;"></i>
              </div>
              <div class="stat-info">
                <span class="stat-label">Quilometragem</span>
                <span class="stat-value">{{ preventiveMaintenance.targetMileage | number }} km</span>
              </div>
            </div>

            <div class="stat-item" *ngIf="preventiveMaintenance.items">
              <div class="stat-icon" style="background: #d1e7dd;">
                <i class="fas fa-list" style="color: #198754;"></i>
              </div>
              <div class="stat-info">
                <span class="stat-label">Itens</span>
                <span class="stat-value">{{ preventiveMaintenance.items.length }}</span>
              </div>
            </div>

            <div class="stat-item" *ngIf="preventiveMaintenance.estimatedCost">
              <div class="stat-icon" style="background: #d1e7dd;">
                <i class="fas fa-money-bill-wave" style="color: #198754;"></i>
              </div>
              <div class="stat-info">
                <span class="stat-label">Custo Estimado</span>
                <span class="stat-value">{{ preventiveMaintenance.estimatedCost | currency:'BRL':'symbol':'1.2-2' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal para Adicionar Item -->
  <div class="modal fade" [class.show]="showAddItemModal" [style.display]="showAddItemModal ? 'block' : 'none'" 
       tabindex="-1" role="dialog" *ngIf="showAddItemModal">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="fas fa-plus me-2"></i>
            Adicionar Item à Preventiva
          </h5>
          <button type="button" class="btn-close" (click)="closeAddItemModal()"></button>
        </div>
        <div class="modal-body">
          <form [formGroup]="itemForm">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Item do Estoque</label>
                <select 
                  class="form-select"
                  formControlName="itemId"
                  (change)="onStockItemSelected($any($event.target).value)">
                  <option value="">Selecione um item do estoque...</option>
                  <option *ngFor="let stockItem of stockItems" [value]="stockItem.id">
                    {{ stockItem.name }} ({{ stockItem.code }}) - Qtd: {{ stockItem.quantity }} {{ stockItem.unit }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label class="form-label">Nome do Item *</label>
                <input 
                  type="text"
                  class="form-control"
                  formControlName="itemName"
                  [class.is-invalid]="itemForm.get('itemName')?.invalid && itemForm.get('itemName')?.touched"
                  placeholder="Ex: Troca de Óleo">
                <div class="invalid-feedback" *ngIf="itemForm.get('itemName')?.invalid && itemForm.get('itemName')?.touched">
                  Nome do item é obrigatório
                </div>
              </div>

              <div class="col-md-12">
                <label class="form-label">Descrição</label>
                <textarea 
                  class="form-control"
                  formControlName="description"
                  rows="2"
                  placeholder="Descrição do item..."></textarea>
              </div>

              <div class="col-md-12">
                <label class="form-label">Instruções</label>
                <textarea 
                  class="form-control"
                  formControlName="instructions"
                  rows="2"
                  placeholder="Instruções para este item..."></textarea>
              </div>

              <div class="col-md-3">
                <label class="form-label">Quantidade *</label>
                <input 
                  type="number"
                  class="form-control"
                  formControlName="quantity"
                  step="0.01"
                  min="0.01"
                  [class.is-invalid]="itemForm.get('quantity')?.invalid && itemForm.get('quantity')?.touched">
                <div class="invalid-feedback" *ngIf="itemForm.get('quantity')?.invalid && itemForm.get('quantity')?.touched">
                  Quantidade é obrigatória e deve ser maior que zero
                </div>
              </div>

              <div class="col-md-3">
                <label class="form-label">Unidade *</label>
                <select 
                  class="form-select"
                  formControlName="unit"
                  [class.is-invalid]="itemForm.get('unit')?.invalid && itemForm.get('unit')?.touched">
                  <option value="">Selecione...</option>
                  <option *ngFor="let unit of units" [value]="unit">
                    {{ unit }}
                  </option>
                </select>
              </div>

              <div class="col-md-3">
                <label class="form-label">Tipo de Item</label>
                <select 
                  class="form-select"
                  formControlName="itemType">
                  <option *ngFor="let type of itemTypes" [value]="type">
                    {{ type }}
                  </option>
                </select>
              </div>

              <div class="col-md-3">
                <label class="form-label">Custo Estimado (R$)</label>
                <input 
                  type="number"
                  class="form-control"
                  formControlName="estimatedCost"
                  step="0.01"
                  min="0"
                  placeholder="0.00">
              </div>

              <div class="col-md-3">
                <label class="form-label">Ordem</label>
                <input 
                  type="number"
                  class="form-control"
                  formControlName="orderIndex"
                  min="0"
                  [value]="preventiveMaintenance?.items?.length || 0">
              </div>

              <div class="col-md-3">
                <div class="form-check form-switch mt-4">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    formControlName="isRequired">
                  <label class="form-check-label">
                    Item Obrigatório
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeAddItemModal()">
            <i class="fas fa-times me-2"></i>
            Cancelar
          </button>
          <button type="button" class="btn btn-primary" (click)="addItemToPreventiveMaintenance()" [disabled]="isSubmittingItem">
            <i class="fas fa-save me-2"></i>
            {{ isSubmittingItem ? 'Adicionando...' : 'Adicionar Item' }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade" [class.show]="showAddItemModal" *ngIf="showAddItemModal"></div>
</app-side-menu>

